import { render } from "./privacityView.vue?vue&type=template&id=035b343e&scoped=true"
import script from "./privacityView.vue?vue&type=script&lang=js"
export * from "./privacityView.vue?vue&type=script&lang=js"

import "./privacityView.vue?vue&type=style&index=0&id=035b343e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/weektodo/weektodo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-035b343e"]])

export default __exports__